import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  BrowserRouter,
  Route
} from 'react-router-dom'

import { isAuthenticated } from '../actions'

import '../styles/style.css'
import Login from '../components/Login'

import PrivateRoutes from './PrivateRoutes'

class Router extends Component {
  componentDidMount () {
    this.props.isAuthenticated()
  }

  render () {
    return (
      <BrowserRouter>
        {
          this.props.user && this.props.user.token
            ? <Route path="/" render={ () => <PrivateRoutes role={this.props.user.user_role}/> } />
            : <Route path="/" component={Login}/>
        }
      </BrowserRouter>
    )
  }
}

function mapStateToProps ({ user }) {
  return { user }
}

export default connect(mapStateToProps, { isAuthenticated })(Router)



// WEBPACK FOOTER //
// ./src/routes/Router.jsx